import { areObjectsDeeplyEqual } from '@vfde-sails/utils';
import { StateProps } from './';

/**
 * Helper function to help determine which part of the UI
 * needs to be updated based on state changes
 * @param {StateProps} props - new state
 * @param {StateProps} oldProps - old state
 * @returns {Object} - object containing booleans
 */
export const getUpdateFlags = (props: StateProps, oldProps: StateProps) => {
    const { isAppLoading, isOverlayLoading, isError, isGigakombi, overlay, availability, product, selected, customer } = props;

    const selectedChanged = !areObjectsDeeplyEqual(selected, oldProps.selected);
    const availabilityChanged = !areObjectsDeeplyEqual(availability, oldProps.availability);
    const productTypeChanged = selected.type !== oldProps.selected.type;
    const productChanged = !areObjectsDeeplyEqual(product, oldProps.product);
    const customerChanged = !areObjectsDeeplyEqual(customer, oldProps.customer);

    return {
        error: isError !== oldProps.isError,
        appSpinner: isAppLoading !== oldProps.isAppLoading,
        gigakombiContainer: productTypeChanged,
        gigakombi: isGigakombi !== oldProps.isGigakombi || customerChanged,
        overlaySpinner: isOverlayLoading !== oldProps.isOverlayLoading,
        overlayVisibility: overlay.isOpen !== oldProps.overlay.isOpen,
        overlayView: overlay.view !== oldProps.overlay.view,
        overlayLoaded: overlay.isLoaded && overlay.isLoaded !== oldProps.overlay.isLoaded,
        footnoteAccordion: availabilityChanged,
        footnotes: selectedChanged || availabilityChanged || productChanged,
        qualitySeal: productTypeChanged,
        deviceTabs: selected.device !== oldProps.selected.device,
        customer: customerChanged,
    };
};
